import { __assign } from '../../../tslib/tslib.es6.js';
import * as React from 'react';
import { RemoveScroll } from './UI.js';
import SideCar from './sidecar.js';
var ReactRemoveScroll = React.forwardRef(function (props, ref) {
  return React.createElement(RemoveScroll, __assign({}, props, {
    ref: ref,
    sideCar: SideCar
  }));
});
ReactRemoveScroll.classNames = RemoveScroll.classNames;
var $am6gm$RemoveScroll = ReactRemoveScroll;
export { $am6gm$RemoveScroll as default };
//# sourceMappingURL=Combination.js.map
